/* eslint-disable import/prefer-default-export */
import API from './api';

export const postObterBoletoAreaCliente = (payload, config = {}) =>
  API.post(`${process.env.REACT_APP_API_BASE_AREA_CLIENTE_PATH}/obter-boleto`, payload, { ...config });

export const postObterBoletoAreaSacado = (payload = {}, config = {}) =>
  API.post('/area-sacado/obter-boleto', payload, { ...config });
